<template>
  <div>
    <v-popover offset="16" placement="top">
      <info-icon alt="tooltip" :class="{ 'tooltip--dark': dark }" />
      <template slot="popover">
        <slot />
      </template>
    </v-popover>
  </div>
</template>

<script>
import { VPopover } from "v-tooltip";
import InfoIcon from "@/assets/images/info.svg";

export default {
  name: "BaseTooltip",
  components: {
    VPopover,
    InfoIcon
  },
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.tooltip--dark path {
  fill: $color-blue-300;
  opacity: .2;
}

.v-popover,
.v-popover .trigger {
  padding-bottom: 2px;
  height: 14px;
}

.vue-popover-theme {
  z-index: $z-index-4;
  max-width: 95%;
  word-wrap: break-word;

  .tooltip-inner {
    background: $color-white;
    color: $color-grey-300;
    font-size: $font-size-m;
    box-shadow: 0 0 40px 0 rgba(0, 0, 0, .1);
    padding: 15px 20px;
    max-height: 300px;
    max-width: 100%;
    overflow-y: scroll;
  }

  .tooltip-arrow {
    @include sizing(0);

    border-style: solid;
    position: absolute;
    margin: 0 5px;
    border-color: $color-white;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    left: calc(50% - 8px);
  }

  &[x-placement^="top"] {
    .tooltip-arrow {
      border-width: 8px 6px 0 6px;
      border-bottom-color: transparent !important;
      bottom: -8px;
    }
  }

  &[x-placement^="bottom"] {
    .tooltip-arrow {
      border-width: 0 6px 8px 6px;
      border-top-color: transparent !important;
      top: -8px;
    }
  }
}

@media screen and (min-width: $media-l) {
  .vue-popover-theme {
    max-width: 500px;
  }
}
</style>
